import React from 'react';
import { bool, string } from 'prop-types';
import clsx from 'clsx';
import { FormattedMessage } from '../../../../util/reactIntl';
import { propTypes } from '../../../../util/types';
import freeCancellationImage from './images/icon-money.svg';
import supportImage from './images/icon-support.svg';
import smartAccessImage from './images/icon-ticket.svg';

import css from './SectionKeyPoints.module.css';

const SectionKeyPoints = props => {
  const { rootClassName, className } = props;

  const classes = clsx(rootClassName || css.root, className);
  return (
    <div className={classes}>
      <div className={css.title}>
        <FormattedMessage id="SectionKeyPoints.title" />
        <br />
      </div>
      <div className={css.steps}>
        <div className={css.step}>
          <img className={css.keyPointIcon} src={smartAccessImage} alt="ticket icon" />
          <p className={css.stepTitle}>
            <FormattedMessage id="SectionKeyPoints.titleKeyOne" />
          </p>
          <p className={css.text}>
            <FormattedMessage id="SectionKeyPoints.textKeyOne" />
          </p>
        </div>

        <div className={css.step}>
          <img className={css.keyPointIcon} src={freeCancellationImage} alt="money icon" />
          <p className={css.stepTitle}>
            <FormattedMessage id="SectionKeyPoints.titleKeyTwo" />
          </p>
          <p className={css.text}>
            <FormattedMessage id="SectionKeyPoints.textKeyTwo" />
          </p>
        </div>

        <div className={css.step}>
          <img className={css.keyPointIcon} src={supportImage} alt="support agent icon" />
          <p className={css.stepTitle}>
            <FormattedMessage id="SectionKeyPoints.titleKeyThree" />
          </p>
          <p className={css.text}>
            <FormattedMessage id="SectionKeyPoints.textKeyThree" />
          </p>
        </div>
      </div>
    </div>
  );
};

SectionKeyPoints.defaultProps = {
  rootClassName: null,
  className: null,
  currentUserListing: null,
  currentUserListingFetched: false,
};

SectionKeyPoints.propTypes = {
  rootClassName: string,
  className: string,
  currentUserListing: propTypes.ownListing,
  currentUserListingFetched: bool,
};

export default SectionKeyPoints;
